/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

import { useEffect } from 'react';
import { isMotiliAccount } from 'common/services/AuthService';

export const useZenDeskChat = () => {
    useEffect(() => {
        const zenDeskChatTimer = setTimeout(() => {
            if (window.zE) {
                if (isMotiliAccount()) {
                    window.zE('webWidget', 'updateSettings', {
                        webWidget: {
                            chat: {
                                suppress: true,
                            },
                        },
                    });
                } else {
                    window.zE('webWidget', 'updateSettings', {
                        webWidget: {
                            chat: {
                                suppress: false,
                            },
                        },
                    });
                    window.zE('webWidget', 'toggle');
                    window.zE('webWidget', 'close');
                }
            }
        }, 1500);

        return () => {
            clearTimeout(zenDeskChatTimer);
        };
    }, []);
};
